import { render, staticRenderFns } from "./BToggleableDisplayButton.vue?vue&type=template&id=f2ce8fda&"
import script from "./BToggleableDisplayButton.vue?vue&type=script&lang=js&"
export * from "./BToggleableDisplayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2ce8fda')) {
      api.createRecord('f2ce8fda', component.options)
    } else {
      api.reload('f2ce8fda', component.options)
    }
    module.hot.accept("./BToggleableDisplayButton.vue?vue&type=template&id=f2ce8fda&", function () {
      api.rerender('f2ce8fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/BToggleableDisplayButton.vue"
export default component.exports